import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {
  TextInput,
  RichTextInput,
  TextAreaInput,
  Base64FileInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";

let ProductSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      'has text',
      'Article content is required',
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, '').length > 0
    ),
  title: Yup.string()
    .required('Summary title is required')
    .max(150),
  image: Yup.mixed()
    .required('Product image is required'),
  desc: Yup.string()
    .required('Summary is required')
    .max(150),
});

export default function ProductForm({
  pitch:{product_section={}, pitchable_id}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(product_section === null) product_section = {};

  const defaultValues = {
    title: product_section.title || '',
    desc: product_section.desc || '',
    content: RichTextInput.createState(product_section.content || ""),
    image: "",
  }

  const methods = useForm({
    resolver: yupResolver(ProductSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
    methods.setValue("title", product_section.title || "");
    methods.setValue("desc", product_section.desc || "");
    methods.setValue("content", RichTextInput.createState(product_section.content || ""));
  }, [methods, product_section]);

  const onSubmit = values => {
    const {content, title, image, desc} = values
    let updatedValues = {
      pitch: {
        product_section_attributes:{
          title,
          desc,
          image,
          content: RichTextInput.contentForSave(content),
        }
      }
    }
    if(!image) delete updatedValues.pitch.product_section_attributes.image

    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: updatedValues,
    })
  }

  return(
    <div id="productForm" className="small-section-bottom">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "412px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Brief summary</label>
              <TextInput
                name="title"
                placeholder="Brief summary (max 150 chars)"
              />
              <div className="mb-2">
                <Base64FileInput
                  name="image"
                  prevUrl={product_section.image_url}
                  containerSizingClass="product-image"
                />
              </div>
              <TextAreaInput
              name="desc"
              placeholder="Description"
            />
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={product_section.id} sectionType="product"/>
            <LastUpdatedAt updatedAt={ product_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
